// extracted by css-extract-rspack-plugin
export default {"layoutNavLink":"layoutNavLink__M9cil","layoutNavLink__icon":"layoutNavLink__icon__RBlem","layoutNavLink_active":"layoutNavLink_active__z83jr"};